import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const path = location.pathname;
  const [open, setOpen] = useState(false);
  const [auctionOpen, setAuctionOpen] = useState(false);
  const auctionRef = useRef(null);
  const isAuctionPath = path.startsWith('/auction') && path !== '/auction/admin';

  // Close dropdown on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (auctionRef.current && !auctionRef.current.contains(e.target)) {
        setAuctionOpen(false);
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  const closeAll = () => {
    setOpen(false);
    setAuctionOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo-left">
        <Link to="/">
          <div className="navbar-brand-lockup">
            <img className="navbar-logo-wordmark" src="/images/pg_main_logo.webp" alt="PG logo" />
          </div>
        </Link>
      </div>
      <ul className={`navbar-links${open ? ' active' : ''}`}>
        <li>
          <Link to="/" className={path === '/' ? 'active' : ''} onClick={closeAll}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/teams" className={path === '/teams' ? 'active' : ''} onClick={closeAll}>
            Teams
          </Link>
        </li>
        <li>
          <Link to="/players" className={path === '/players' ? 'active' : ''} onClick={closeAll}>
            Players
          </Link>
        </li>
        <li>
          <Link to="/fixtures" className={path === '/fixtures' ? 'active' : ''} onClick={closeAll}>
            Fixtures
          </Link>
        </li>
        {/* Auction dropdown */}
        <li className="navbar-dropdown" ref={auctionRef}>
          <button
            type="button"
            className={`navbar-dropdown-toggle${isAuctionPath ? ' active' : ''}`}
            onClick={() => setAuctionOpen(!auctionOpen)}
            aria-expanded={auctionOpen}
          >
            Auction <span className={`caret${auctionOpen ? ' caret-up' : ''}`}>▾</span>
          </button>
          <ul className={`navbar-dropdown-menu${auctionOpen ? ' show' : ''}`}>
            <li>
              <Link to="/auction/pool" className={path === '/auction/pool' ? 'active' : ''} onClick={closeAll}>
                Player Pool
              </Link>
            </li>
            <li>
              <Link to="/auction/results" className={path === '/auction/results' ? 'active' : ''} onClick={closeAll}>
                Results
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <Link to="/rules" className={path === '/rules' ? 'active' : ''} onClick={closeAll}>
            Rules
          </Link>
        </li>
      </ul>
      <div className="navbar-hamburger" onClick={() => setOpen(!open)}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
      <div className="navbar-logo-right">
        <Link to="/">
          <img src="/images/vpl_logo.webp" alt="Valorant Phantom League" />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;